module.exports = __webpack_public_path__ + "img/MELA_Fibroblasts.6a547af8.png";